import { useEffect } from 'react';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import HomeAboutSection from './components/HomeAboutSection';

const baseUrl = 'http://kiyvx.cn/';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '178漫画网',
    url: baseUrl,
    description: '178漫画网推出洞洞杂货铺高清漫画全集免费阅读下拉式服务，超清画质+流畅体验，视觉盛宴。',
    sameAs: [
      'http://kiyvx.cn/',
      'http://kiyvx.cn/178manhua',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '178漫画网',
    url: baseUrl,
    description: '高清漫画全集免费阅读下拉式平台，洞洞杂货铺等热门漫画随心看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${baseUrl}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '178漫画网 - 高清漫画全集免费阅读下拉式',
    description: '178漫画网推出洞洞杂货铺高清漫画全集免费阅读下拉式服务，超清画质+流畅体验，视觉盛宴。',
    url: baseUrl,
    isPartOf: { '@id': `${baseUrl}/#website` },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: baseUrl,
      },
    ],
  },
];

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title="洞洞杂货铺漫画-高清漫画全集免费阅读下拉式"
        description="178漫画网推出洞洞杂货铺高清漫画全集免费阅读下拉式服务，超清画质+流畅体验，视觉盛宴。涵盖治愈、热血、恋爱、悬疑等多种类型漫画，每日更新，免费阅读。"
        keywords="洞洞杂货铺,高清,漫画全集,免费阅读,下拉式,178漫画网,治愈漫画,热血漫画,恋爱漫画,悬疑漫画"
        canonicalUrl={baseUrl}
        ogImage="https://readdy.ai/api/search-image?query=Warm%20whimsical%20anime%20style%20illustration%20of%20a%20mysterious%20curio%20shop%20with%20glowing%20lanterns%2C%20cozy%20fantasy%20atmosphere%2C%20178%20comic%20website%20og%20image%2C%20storybook%20quality&width=1200&height=630&seq=og-home-01&orientation=landscape"
        jsonLd={homeJsonLd}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <LatestSection />
          <HomeAboutSection />
        </main>
        <Footer />
      </div>
    </>
  );
}